import { css } from 'styled-components';
import { CFBaseFieldHelpers } from './styles';
import { CFTokens } from '../../tokens';
import { CFMixins } from '../../mixins';
export const CFBaseFieldStyles = {
    FieldControl: css `
    position: absolute;
    z-index: 1;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border: 0;
    background-color: transparent;
    color: ${CFBaseFieldHelpers.textInputColor};
    ${CFBaseFieldHelpers.controlPadding};
  `,
    FieldControlFullType: css `
    ${CFBaseFieldHelpers.textInputTypeSpec};
  `,
    FieldControlSimpleType: css `
    ${CFBaseFieldHelpers.textInputFontSize};
  `,
    FieldDecorator: css `
    position: relative;
    z-index: ${CFBaseFieldHelpers.decoratorZIndex};
    pointer-events: ${CFBaseFieldHelpers.decoratorPointerEvent};
  `,
    FieldRoot: css `
    background-color: ${CFBaseFieldHelpers.rootBackgroundColor};
    ${CFBaseFieldHelpers.rootBoxModel};
    ${CFBaseFieldHelpers.rootBorder};
  `,
    FieldToggleOptionContainer: css `
    width: 100%;
    display: flex;
    gap: ${CFTokens.SPACER.B}px;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  `,
    FieldToggleOptionLabel: css `
    color: ${CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT};
    ${CFMixins.typeSpec(CFTokens.TYPE_SPEC_SCALE.F_SEMIBOLD_LOOSE)}
  `,
    FieldValue: css `
    flex: 1;
    text-align: left;
    color: ${CFBaseFieldHelpers.valueColor};
    ${CFBaseFieldHelpers.valueTypeSpec};
  `,
    FieldValueWeb: css `
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
    FieldWrapper: css `
    ${CFBaseFieldHelpers.wrapperBoxModel};
    z-index: 2;
  `,
    FieldWrapperWeb: css `
    pointer-events: none;
  `,
};
